import { reduce } from "et3-type-guards";
import { useEffect } from "react";
import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import ET3PageDiv from "../../core/et3-page-div";
import Et3PageTitle from "../../core/et3-page-title/index";
import Et3Margin from "../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import getRootStore from "../../stores/core/root-store";
import getDashBoardStore from "../../stores/dashboard-store";
import AlarmDetails from "./AlarmDetails";
import AlarmTeam from "./AlarmTeam";
import Item from "./Item";

const Dashboard = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  useEffect(() => {
    getCoreHistoryStore().setPageName("ALARMS", "ALARMS");
  }, []);
  const {
    newUsersAlert,
    fbUsersAlert,
    smsUsersAlert,
    emailUsersAlert,
    lastLoginUsersAlert,
    androidPaymentsAlert,
    iosPaymentsAlert,
    flaggedConnectionAlert,
    flaggedConnectionAppAlert,
    flaggedConnectionWebAlert,
    flaggedConnectionAdminAlert,
    rateLimitBlockedAppAlert,
    rateLimitBlockedWebAlert,
    rateLimitBlockedAdminAlert,
    rateLimitBlockedAlert,
    alertDate,
    lastAlarmsCheckDateAlert,
    sentEmailsAlert,
    unsubscribedUserActivityEmailsAlert,
    unsubscribedPromotionalEmailsAlert,
    unsubscribedNewMessageEmailsAlert,
    unsubscribedVisitProfileEmailsAlert,
    unsubscribedLikeEmailsAlert,
    ipGeolocationAlert,
    bpUserAlert
  } = getDashBoardStore().alertsData.get();
  const isAlert = getDashBoardStore().getIsAlert.get();
  const alertDateForammted =
    alertDate === 0
      ? "REFRESH_PLEASE"
      : reduce(() => new Date(alertDate).toLocaleString("en-GB"), "");
  const approvalCount = getDashBoardStore().approvalCount.get();
  const reportsCount = getDashBoardStore().reportsCount.get();
  const investigationCasesCount =
    getDashBoardStore().investigationCasesCount.get();

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("DASHBOARD")}
        subTitle={i18n.get("CONTROL_PANEL")}
        withRefresh={true}
        withHelper={false}
        onPress={async () => {
          await getRootStore().refreshData();
        }}
      />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1300}
        height={80}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{}}
        alignItems="center"
        justifyContent="space-between"
        onClick={() => {}}
      >
        <Item
          title={i18n.get("APPROVE_REJECT")}
          data={`${approvalCount}`}
          inDanger={false}
        />
        <Item
          title={i18n.get("REPORTS")}
          data={`${reportsCount}`}
          inDanger={false}
        />

        <Item
          title={i18n.get("INVESTIGATION_CASES")}
          data={`${investigationCasesCount}`}
          inDanger={false}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1300}
        height={80}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{}}
        alignItems="center"
        justifyContent="space-between"
        onClick={() => {}}
      >
        <Item
          title={`${alertDateForammted}`}
          data={
            lastAlarmsCheckDateAlert ? i18n.get("DANGER") : i18n.get("SAFE")
          }
          inDanger={lastAlarmsCheckDateAlert}
        />

        <Item
          title={i18n.get("ALERT")}
          data={isAlert ? i18n.get("DANGER") : i18n.get("SAFE")}
          inDanger={isAlert}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1300}
        height={80}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{}}
        alignItems="center"
        justifyContent="space-between"
        onClick={() => {}}
      >
        <Item
          title={i18n.get("EMAIL_USERS")}
          data={emailUsersAlert ? i18n.get("DANGER") : i18n.get("SAFE")}
          inDanger={emailUsersAlert}
        />
        <Item
          title={i18n.get("FB_USERS")}
          data={fbUsersAlert ? i18n.get("DANGER") : i18n.get("SAFE")}
          inDanger={fbUsersAlert}
        />

        <Item
          title={i18n.get("SMS_USERS")}
          data={smsUsersAlert ? i18n.get("DANGER") : i18n.get("SAFE")}
          inDanger={smsUsersAlert}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />

      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1300}
        height={80}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{}}
        alignItems="center"
        justifyContent="space-between"
        onClick={() => {}}
      >
        <Item
          title={i18n.get("NEW_USERS")}
          data={newUsersAlert ? i18n.get("DANGER") : i18n.get("SAFE")}
          inDanger={newUsersAlert}
        />
        <Item
          title={i18n.get("BP_USERS")}
          data={bpUserAlert ? i18n.get("DANGER") : i18n.get("SAFE")}
          inDanger={bpUserAlert}
        />
        <Item
          title={i18n.get("LAST_LOGIN_USERS")}
          data={lastLoginUsersAlert ? i18n.get("DANGER") : i18n.get("SAFE")}
          inDanger={lastLoginUsersAlert}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1300}
        height={80}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{}}
        alignItems="center"
        justifyContent="space-between"
        onClick={() => {}}
      >
        <Item
          title={i18n.get("SENT_EMAILS")}
          data={sentEmailsAlert ? i18n.get("DANGER") : i18n.get("SAFE")}
          inDanger={sentEmailsAlert}
        />
        <Item
          title={i18n.get("UNSUBSCRIBED_USER_ACTIVITY_EMAILS")}
          data={
            unsubscribedUserActivityEmailsAlert
              ? i18n.get("DANGER")
              : i18n.get("SAFE")
          }
          inDanger={unsubscribedUserActivityEmailsAlert}
        />
        <Item
          title={i18n.get("UNSUBSCRIBED_PROMOTIONAL_EMAILS")}
          data={
            unsubscribedPromotionalEmailsAlert
              ? i18n.get("DANGER")
              : i18n.get("SAFE")
          }
          inDanger={unsubscribedPromotionalEmailsAlert}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1300}
        height={80}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{}}
        alignItems="center"
        justifyContent="space-between"
        onClick={() => {}}
      >
        <Item
          title={i18n.get("UNSUBSCRIBED_NEW_MESSAGE_EMAILS")}
          data={
            unsubscribedNewMessageEmailsAlert
              ? i18n.get("DANGER")
              : i18n.get("SAFE")
          }
          inDanger={unsubscribedNewMessageEmailsAlert}
        />
        <Item
          title={i18n.get("UNSUBSCRIBED_VISIT_PROFILE_EMAILS")}
          data={
            unsubscribedVisitProfileEmailsAlert
              ? i18n.get("DANGER")
              : i18n.get("SAFE")
          }
          inDanger={unsubscribedVisitProfileEmailsAlert}
        />
        <Item
          title={i18n.get("UNSUBSCRIBED_LIKE_EMAILS")}
          data={
            unsubscribedLikeEmailsAlert ? i18n.get("DANGER") : i18n.get("SAFE")
          }
          inDanger={unsubscribedLikeEmailsAlert}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1300}
        height={80}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{}}
        alignItems="center"
        justifyContent="space-between"
        onClick={() => {}}
      >
        <Item
          title={i18n.get("FLAGGED_CONNECTION")}
          data={flaggedConnectionAlert ? i18n.get("DANGER") : i18n.get("SAFE")}
          inDanger={flaggedConnectionAlert}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1300}
        height={80}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{}}
        alignItems="center"
        justifyContent="space-between"
        onClick={() => {}}
      >
        <Item
          title={i18n.get("FLAGGED_CONNECTION_APP")}
          data={
            flaggedConnectionAppAlert ? i18n.get("DANGER") : i18n.get("SAFE")
          }
          inDanger={flaggedConnectionAppAlert}
        />
        <Item
          title={i18n.get("FLAGGED_CONNECTION_WEB")}
          data={
            flaggedConnectionWebAlert ? i18n.get("DANGER") : i18n.get("SAFE")
          }
          inDanger={flaggedConnectionWebAlert}
        />
        <Item
          title={i18n.get("FLAGGED_CONNECTION_ADMIN")}
          data={
            flaggedConnectionAdminAlert ? i18n.get("DANGER") : i18n.get("SAFE")
          }
          inDanger={flaggedConnectionAdminAlert}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1300}
        height={80}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{}}
        alignItems="center"
        justifyContent="space-between"
        onClick={() => {}}
      >
        <Item
          title={i18n.get("RATE_LIMIT")}
          data={rateLimitBlockedAlert ? i18n.get("DANGER") : i18n.get("SAFE")}
          inDanger={rateLimitBlockedAlert}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1300}
        height={80}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{}}
        alignItems="center"
        justifyContent="space-between"
        onClick={() => {}}
      >
        <Item
          title={i18n.get("RATE_LIMIT_MOBILE_APP")}
          data={
            rateLimitBlockedAppAlert ? i18n.get("DANGER") : i18n.get("SAFE")
          }
          inDanger={rateLimitBlockedAppAlert}
        />
        <Item
          title={i18n.get("RATE_LIMIT_WEBSITE")}
          data={
            rateLimitBlockedWebAlert ? i18n.get("DANGER") : i18n.get("SAFE")
          }
          inDanger={rateLimitBlockedWebAlert}
        />
        <Item
          title={i18n.get("RATE_LIMIT_ADMIN")}
          data={
            rateLimitBlockedAdminAlert ? i18n.get("DANGER") : i18n.get("SAFE")
          }
          inDanger={rateLimitBlockedAdminAlert}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1300}
        height={80}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{}}
        alignItems="center"
        justifyContent="space-between"
        onClick={() => {}}
      >
        <Item
          title={i18n.get("ANDROID_PAYMENTS")}
          data={androidPaymentsAlert ? i18n.get("DANGER") : i18n.get("SAFE")}
          inDanger={androidPaymentsAlert}
        />
        <Item
          title={i18n.get("IOS_PAYMENTS")}
          data={iosPaymentsAlert ? i18n.get("DANGER") : i18n.get("SAFE")}
          inDanger={iosPaymentsAlert}
        />
        <Item
          title={i18n.get("IP_GEOLOCATION")}
          data={ipGeolocationAlert ? i18n.get("DANGER") : i18n.get("SAFE")}
          inDanger={ipGeolocationAlert}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <AlarmTeam />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <AlarmDetails />
    </ET3PageDiv>
  );
});
export default Dashboard;
